import { css } from '@emotion/core';
var spin = {
  name: "1txlktf",
  styles: "@keyframes spin{from{transform:rotate(0deg);}to{transform:rotate(359deg);}}"
};
var animations = /*#__PURE__*/css(spin, ";");
export default animations;